/*eslint-disable*/
import React from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import classNames from "classnames";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import christian from "assets/img/faces/christian.jpg";
import { FaUserEdit } from "react-icons/fa";
import SweetAlert from "react-bootstrap-sweetalert";

import BanglesHeader from "views/BanglesPage/Section/BanglesHeader"
import HeaderLink from "views/BanglesPage/Section/BanglesHeaderLink"
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter"
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

import { Redirect } from "react-router-dom";

const useStyles = makeStyles(profilePageStyle);
const useStyleAlert = makeStyles(style);
const useStyl = makeStyles(aboutUsStyle);

export default function EditProfile({ ...rest }) {
    const [firstname, setFristname] = React.useState("");
    const [lastname, setLastname] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [alternate, setAlternate] = React.useState("");
    const [whatsapp, setWhatsapp] = React.useState("");
    const [office, setOffice] = React.useState("");
    const [aadharno, setAadharno] = React.useState("");
    const [price, setPrice] = React.useState("");
    const [profit, setProfit] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);
    const [alertMsg, alertMsgOps] = React.useState("");
    const [alertType, alertTypeOps] = React.useState("");

    // React.useEffect(() => {
    //     window.scrollTo(0, 0);
    //     document.body.scrollTop = 0;
    // });
    const classes = useStyles();
    const classeAlert = useStyleAlert();
    const classeTitel = useStyl();

    const activeSession = sessionStorage.getItem("sessionData");
    let userObj = JSON.parse(sessionStorage.getItem("sessionData"));
    // const headApi = `https://api.bangles.org.in/api/rest`;

    React.useEffect(() => {
        axios.get(headApi + `/user/${userObj && userObj.mobile}`)
            .then((res) => {
                // console.log(res.data);
                setFristname(res.data.firstname);
                setLastname(res.data.lastname);
                setEmail(res.data.email);
                setAlternate(res.data.alternate);
                setWhatsapp(res.data.whatsapp);
                setOffice(res.data.office);
                setAadharno(res.data.aadharno);
                setPrice(res.data.price);
                setProfit(res.data.profit);
            })
    }, []);

    const SubmitProfile = (event) => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                mobile: userObj.mobile,
                firstname: firstname,
                lastname: lastname,
                email: email,
                alternate: alternate,
                whatsapp: whatsapp,
                office: office,
                aadharno: aadharno,
                price: price,
                profit: profit,
            }),
        };

        fetch(
            headApi + "/user/profile",
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if (data.message === "Profile Edited Successfully") {
                    setSubmitted(true);
                    alertTypeOps("success");
                    alertMsgOps("Updated Successfully");
                }
            })

            .catch((err) => {
                console.log(err);
            });
    };

    const hideAlert = () => {
        setSubmitted(false);
        window.location.reload(false);
    };

    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );
    const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
    return (
        <div>
            {activeSession ? <>
                <Helmet>
                    <title>Edit Profile</title>
                </Helmet>
                <BanglesHeader
                    color="info"
                    brand="Home"
                    links={<HeaderLink dropdownHoverColor="info" />}
                    fixed
                    // changeColorOnScroll={{
                    //     height: 200,
                    //     color: "info",
                    // }}
                    {...rest}
                />
                <Parallax
                    image={require("assets/img/examples/city.jpg").default}
                    filter="dark"
                    className={classes.parallax}
                >
                    <div className={classeTitel.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={8}
                                sm={8}
                                className={classNames(
                                    classeTitel.mlAuto,
                                    classeTitel.mrAuto,
                                    classeTitel.textCenter
                                )}
                            >
                                <h1 className={classeTitel.title}>PROFILE</h1>
                                <h4>

                                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        {submitted ? (
                            <SweetAlert
                                type={alertType}
                                style={{ display: "block", marginTop: "100px" }}
                                title={alertMsg}
                                onConfirm={() => hideAlert()}
                                confirmBtnCssClass={
                                    classeAlert.button + " " + classeAlert.success
                                }
                            />
                        ) : null}
                        {/* <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <div className={classes.profile}>
                                    <div>
                                        <img src={christian} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>CEO</h3>
                                        <h6>FirstName</h6>
                                        <Button
                                            justIcon
                                            simple
                                            color="dribbble"
                                            className={classes.margin5}
                                        >
                                            <i className={classes.socials + " fab fa-dribbble"} />
                                        </Button>
                                        <Button
                                            justIcon
                                            simple
                                            color="twitter"
                                            className={classes.margin5}
                                        >
                                            <i className={classes.socials + " fab fa-twitter"} />
                                        </Button>
                                        <Button
                                            justIcon
                                            simple
                                            color="pinterest"
                                            className={classes.margin5}
                                        >
                                            <i className={classes.socials + " fab fa-pinterest"} />
                                        </Button>
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <div className={classNames(classes.description, classes.textCenter)}>
                            <p>
                                An artist of considerable range, Chet Faker — the name taken by
                                Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs
                                and records all of his own music, giving it a warm, intimate feel
                                with a solid groove structure.{" "}
                            </p>
                            <ImageUpload
                                avatar
                                addButtonProps={{ round: true, color: "info" }}
                                changeButtonProps={{ round: true, color: "info" }}
                                removeButtonProps={{ round: true, color: "danger" }}
                            />

                        </div> */}
                        <div className={classes.profileTabs}>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={6}>
                                    <div className={classes.profile}>
                                        <h3 className={classes.title}> <FaUserEdit color="#00acc1" size={35} /> Edit Profile</h3>
                                    </div>
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="First Name"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "First Name...",
                                            onChange: (e) => setFristname(e.target.value),
                                            name: "firstname",
                                            value: firstname,
                                        }}
                                        id="firstName"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="Last Name"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "Last Name...",
                                            onChange: (e) => setLastname(e.target.value),
                                            name: "lastname",
                                            value: lastname,
                                        }}
                                        id="lastName"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="Email"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "Email...",
                                            onChange: (e) => setEmail(e.target.value),
                                            name: "email",
                                            value: email,
                                        }}
                                        id="email"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="Alternate Number"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "Alternate Number...",
                                            onChange: (e) => setAlternate(e.target.value),
                                            name: "alternate",
                                            value: alternate,
                                        }}
                                        id="alternate"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="WhatsApp Number"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "WhatsApp Number...",
                                            onChange: (e) => setWhatsapp(e.target.value),
                                            name: "whatsapp",
                                            value: whatsapp,
                                        }}
                                        id="whatsapp"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="Office Number"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "Office Number...",
                                            onChange: (e) => setOffice(e.target.value),
                                            name: "office",
                                            value: office,
                                        }}
                                        id="office"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}>
                                    <CustomInput
                                        labelText="Aadhar Number"
                                        formControlProps={{
                                            fullWidth: true,
                                            className: classes.customFormControlClasses,
                                        }}
                                        inputProps={{
                                            placeholder: "Aadhar number...",
                                            onChange: (e) => setAadharno(e.target.value),
                                            name: "aadharno",
                                            value: aadharno,
                                        }}
                                        id="aadhar"
                                    //   required={true}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5}></GridItem>
                            </GridContainer>
                            <br />
                            <GridContainer justify="center">
                                <Button color="info" round onClick={SubmitProfile}>Save</Button>
                            </GridContainer>
                        </div>
                        <br />
                    </div>
                </div>
                <BanglesFooter />
            </> : <Redirect to="/" />}
        </div>
    );
}
